module.exports = __webpack_public_path__ + "img/image-bmp.6f90c30b.png";